import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as eventCountdown from './scripts/event-countdown';
eventCountdown.init();

import * as imageGallerySlider from './scripts/image-gallery-slider';
imageGallerySlider.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();